<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="700"
      transition="dialog-bottom-transition"
      persistent
      scrollable>
      <v-card v-if="show">
        <v-card-title>
          <h1>{{ $t('serverModel.components.guestDialog.share','SHARE') }}</h1>
          <v-spacer />
          <v-icon
            @click="show = false"
            small>
            fas fa-times
          </v-icon>
        </v-card-title>
        <v-card-text>
          <label>{{ $t('serverModel.components.guestDialog.description','Description :') }}</label>
          <v-textarea
            v-model="newShare.description"
            :auto-grow="false"
            :no-resize="true"
            :rows="8" />
          <label>{{ $t('serverModel.components.guestDialog.guestList','Guest list :') }}</label>
          <we-schema-select-multiple
            :data-source="userDataSource"
            :value.sync="newShare.users" />
          <v-chip
            v-for="(email, index) in newShare.externalEmails"
            :key="index"
            @input="removeExternalEmail(email)"
            close>
            {{ email }}
          </v-chip>
          <v-form
            class="add-external-email"
            @submit.prevent="addExternalEmail">
            <v-text-field
              v-model="externalEmail"
              :rules="externalEmailRules"
              :placeholder="$t('serverModel.components.guestDialog.addExternal','Add external email')">
              <template slot="append">
                <v-btn
                  class="mx-0"
                  v-if="externalEmail"
                  @click="addExternalEmail"
                  depressed>
                  <v-icon
                    left
                    small>
                    fa fa-plus
                  </v-icon>
                  {{ $t('serverModel.components.guestDialog.add','Add') }}
                </v-btn>
              </template>
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <label>{{ $t('serverModel.components.guestDialog.expired','Expired on') }}</label>
            <we-schema-date-picker :value.sync="newShare.expiredOn" />
          </div>
          <v-spacer />
          <v-btn
            :disabled="!isValid"
            @click="share">
            <v-icon
              small
              left>
              fas fa-share
            </v-icon>
            {{ $t('serverModel.components.guestDialog.share','SHARE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { shareDataSource, userDataSource } from '../services'
import { mapActions, mapState } from 'vuex'
import { SHARE_TYPOLOGIES, BUSINESS_RULES } from '../constants'
function getDatePlusOne () {
  const date = new Date()
  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + 1)
  return date
}
function defaultShare () {
  return {
    shareTypologyName: SHARE_TYPOLOGIES.FOR_PREVIEW,
    users: {
      content: []
    },
    externalEmails: [],
    description: '',
    expiredOn: getDatePlusOne()
  }
}

export default {
  sync: ['show'],
  data () {
    return {
      userDataSource: userDataSource,
      newShare: defaultShare(),
      externalEmail: '',
      externalEmailRules: [
        value => (!value || BUSINESS_RULES.email.isValid(value)) || BUSINESS_RULES.email.message({ label: 'email' })
      ]
    }
  },
  computed: {
    ...mapState('authentication', [
      'instance'
    ]),
    ...mapState('schema-view', [
      'panelOptionsDefinition'
    ]),
    entity () {
      return this.panelOptionsDefinition && this.panelOptionsDefinition.item
    },
    entitySchema () {
      return this.panelOptionsDefinition && this.panelOptionsDefinition.schema
    },
    isValid () {
      return this.emails && this.emails.length > 0 && this.newShare.expiredOn >= getDatePlusOne()
    },
    emails () {
      return [
        ...this.newShare.users.content.map(u => u.email),
        ...this.newShare.externalEmails
      ]
    }
  },
  methods: {
    ...mapActions('schema-view', [
      'setPanelOptionsDefinition'
    ]),
    addExternalEmail () {
      if (BUSINESS_RULES.email.isValid(this.externalEmail)) {
        this.newShare.externalEmails.push(this.externalEmail)
        this.externalEmail = ''
      }
    },
    removeExternalEmail (email) {
      this.newShare.externalEmails.splice(this.newShare.externalEmails.indexOf(email), 1)
      this.newShare.externalEmails = [...this.newShare.externalEmails]
    },
    async share () {
      const { expiredOn, description } = this.newShare
      const shareDto = {
        shareTypologyName: SHARE_TYPOLOGIES.FOR_PREVIEW,
        emails: this.emails,
        instance: this.instance,
        description,
        expiredOn
      }

      await shareDataSource.create(shareDto, { argsUrl: `entity/${this.entitySchema.name.toLowerCase()}/${this.entity.id}` }, true)
      this.setPanelOptionsDefinition({
        ...this.panelOptionsDefinition,
        fetch: true
      })
      this.newShare = defaultShare()
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-external-email {
    display: inline-table;
  }
</style>
